<app-container [paddingValues]='"18px 16px"' *ngIf="articlesList && articlesList.length >0 ">
    <app-title [title]='"אולי יעניין אותך"'></app-title>
    <div class="articles-slider-continer">
        <owl-carousel-o [options]="customOptions" *ngIf="articlesList.length>2 || 768>screenWidth; else noSlider"> 
        <ng-container *ngFor="let slide of articlesList">
            <ng-template
                carouselSlide
                [id]="slide.title"
            >
                <a class="link-to-articles" href={{slide.link}}>
                    <img
                        [src]="slide.image"
                        [alt]="slide.title"
                        [title]="slide.title"
                    >
                    <span>{{slide.title}}</span>
                </a>

            </ng-template>
        </ng-container>
    </owl-carousel-o>
    <ng-template #noSlider>
        <div  class="continer-articles">
            <div
            *ngFor="let slide of articlesList" class="article"
            >
                <a class="link-to-articles" href={{slide.link}}>
                    <img
                        [src]="slide.image"
                        [alt]="slide.title"
                        [title]="slide.title"
                    >
                    <span>{{slide.title}}</span>
                </a>
    
            </div>
        </div>
    </ng-template>
  
    </div>
</app-container>
